/**
 * @providesModule Identicon
 *
 */

import React from 'react'
import styled, { css } from 'styled-components'

import { identigradient } from 'shared/identigradient'

const NBSP = '\u00A0'

export const identiconStyle = ({
  image,
  hashKey,
  text,
  width,
}) => css`
  background-image: ${({ image, hashKey }) =>
    image ? `url(${image})` : identigradient(hashKey)};
  display: flex;
  align-items: center;
  justify-content: center;
  &::after {
    content: '${({ text, image }) => (image ? NBSP : text[0])}';
    font-weight: 600;
    color: #ebeae4;
    font-size: ${({ width }) => (width >= 25 ? '16px' : '12px')};
  }
`

const IdenticonDiv = styled.div.attrs({
  'aria-label': ({ presentational, text }) => (presentational ? null : text),
  'aria-hidden': ({ presentational }) => (presentational ? 'true' : null),
  role: ({ presentational }) => (presentational ? 'presentational' : null),
  className: 'Identicon',
})`
  width: ${({ width }) => `${width}px`};
  height: ${({ width }) => `${width}px`};
  border-radius: 2px;
  background-size: cover;
  background-position: center;
  ${identiconStyle};
`

const Identicon = ({
  reader,
  width = 36,
  presentational,
  className,
}) => (
  <IdenticonDiv
    presentational={presentational}
    width={width}
    image={reader.imageUrl}
    hashKey={reader.hashKey}
    text={reader.name}
    className={className}
  />
)
export default Identicon
